function renderBB(text) {
    var el = document.createElement('div');
    el.appendChild(document.createTextNode(text));
    return el.innerHTML.replace(renderBB.regex, renderBB.replaceCB);
}

renderBB.tagMap = {
    '[b]': '<b>', '[/b]': '</b>',
    '[i]': '<i>', '[/i]': '</i>',
    '[p]': '<p>', '[/p]': '</p>',
    '[u]': '<u>', '[/u]': '</u>',
    '[h]': '<h5>', '[/h]': '</h5>',
    '[br]': '<br/>'
};

renderBB.regex = new RegExp(
    Object.keys(renderBB.tagMap).join("|").replace(/\[/g, "\\["),
    "gi"
);

renderBB.replaceCB = function(matched) {
    return renderBB.tagMap[matched];
};

export default renderBB;
